module.exports = __webpack_public_path__ + "static/media/services-ios-project-phone-bg-1.ed025f13.svg";